export default '4.2.0';
